import React from 'react';

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'


export class Game extends React.Component {
    constructor() {
        super();

        this.cancel = this.cancel.bind(this);
        this.answer = this.answer.bind(this);
        this.reveal = this.reveal.bind(this);
    }

    componentWillMount() {
        this.canEnd = false;
        this.shown = false;
    }

    reveal() {
        this.shown = true;

        this.props.socket.send(JSON.stringify({ kind: "revealArticle" }));

        setTimeout(() => { this.canEnd = true; this.forceUpdate(); }, 4000);
    }

    answer() {
        this.props.socket.send(JSON.stringify({ kind: "revealAnswer" }));
        this.props.onRevealAnswer();
    }

    cancel() {
        this.props.socket.send(JSON.stringify({ kind: "cancel" }));
        this.props.onCancel();
    }

    render() {
        let content;

        if (this.props.judge) {
            let judgeInteract = <div></div>;

            if (this.canEnd && !this.props.ended) {
                judgeInteract = <>
                    <Row>
                        <Col>
                            <div className="text-muted mt-4 mb-3 text-comment">Appuyer sur ce bouton révèlera qui a choisi l'article</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="success" onClick={this.answer}>
                                Obtenir la réponse
                            </Button>
                        </Col>
                    </Row>
                </>
            } else if (!this.shown) {
                judgeInteract = <>
                    <Row>
                        <Col>
                            <div className="text-muted mt-4 mb-3 text-comment">Seul vous pouvez voir le titre actuellement</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="primary" onClick={this.reveal}>
                                Révéler
                            </Button>
                        </Col>
                    </Row>
                </>
            }

            content = <div>
                <Row>
                    <Col>
                        <span className="word">{this.props.word}</span>
                    </Col>
                </Row>
                {judgeInteract}
            </div>

        } else if (this.props.shown) {
            content = <div>
                <Row>
                    <Col>
                        <span className="word">{this.props.word}</span>
                    </Col>
                </Row>
            </div>
        }

        let admin = <div></div>

        if (this.props.admin) {
            if (this.props.ended) {
                admin = <Button variant="primary" className="mt-5" onClick={this.cancel}>
                    Continuer
                </Button>
            } else {
                admin = <Button variant="danger" className="mt-5" onClick={this.cancel}>
                    Annuler
                </Button>
            }
        }

        let result = <div></div>

        if (this.props.ended) {
            result = <>
                <hr className="divider"/>
                <Row>
                    <Col>
                        <div className="pb-4">
                            Il venait de...
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span className="word">{this.props.answer}</span>
                    </Col>
                </Row>
            </>
        }

        return (<div className="text-center pt-4">
            <Row>
                <Col>
                    <div className="pb-4">
                        L'article est...
                    </div>
                </Col>
            </Row>
            {content}
            {result}
            {admin}
        </div>);
    }
}